<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__heavybag}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
       
        <!-- <el-form-item>
          <el-button v-if="$hasPermission('sys:heavybag:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item> -->
        <el-form-item>
          <el-button v-if="$hasPermission('sys:heavybag:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>

      <el-form :inline="true" :model="exportData" @keyup.enter.native="getDataList()">
      
        <el-form-item>
          <el-input v-model="exportData.type" placeholder="反馈等级" clearable></el-input>
        </el-form-item>

        <el-form-item>
          <renSelect
            v-model="exportData.city"
            dictType="landing_page_city"
            placeholder="城市"
          ></renSelect>
        </el-form-item>
        <el-form-item>
        
          <el-select v-model="exportData.companyId" filterable placeholder="公司">
            <el-option v-for="item in companys" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
    
        <el-form-item>
          <el-button type="info" @click="exportHandle1()">导出排重包</el-button>
        </el-form-item>
      
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="主键id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="userId" label="用户id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="ossUrl"  label="oss链接" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="companyId" label="公司id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="city" label="城市" header-align="center" align="center"></el-table-column>
        <el-table-column prop="callBackType" label="反馈等级" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createBy" label="创建人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateBy" label="更新人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="deleteTime" label="删除时间" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <!-- <el-button v-if="$hasPermission('sys:heavybag:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button> -->
            <el-button v-if="$hasPermission('sys:heavybag:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './heavybag-add-or-update'
import Cookies from 'js-cookie'
import qs from 'qs'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/heavybag/page',
        getDataListIsPage: true,
        exportURL: '/sys/heavybag/export',
        deleteURL: '/sys/heavybag',
        deleteIsBatch: true
      },
      dataForm: {
        id: '',
        // companyId: '1067246875800000066'
        
      },
      exportData:{
        city: '',
        companyId: '',
        type: '',
      },
      companys: [],

    }
  },
  created(){
    this.getcompanies()
  },
  methods: {
    exportHandle1(){
      var params = qs.stringify({
        'token': Cookies.get('token'),
        ...this.exportData
      })
      
      this.$http.post(`/sys/heavybag/export?${params}`).then((r) => {
         
         if(r.data.code != 0){
          this.$message.error(r.data.msg)
         }
      })
    },
    // "/sys/companies/list
    getcompanies(){
     
      this.$http.get(`/sys/companies/list`).then(({ data: res }) => {
          
          if (res.code !== 0) {
              return this.$message.error(res.msg)
          }
          this.companys=[];
          if (res.data!=null){
              res.data.forEach(element => {
                  this.companys.push({label:element.name,value:element.id})
              })
          }
          console.log(this.companys,'999')
      }).catch(() => {})
    },
  },
  components: {
    AddOrUpdate
  }
}
</script>
